'use client';

import { LineLayoutGridIcon, LineLayoutListIcon } from '@/app/_components/icons/line';

export type LayoutFilterValue = 'list' | 'grid';

interface LayoutFilterProps {
  layoutFilterValue: LayoutFilterValue;
  handleLayoutChange: (value: LayoutFilterValue) => void;
}

export default function LayoutFilter({ layoutFilterValue, handleLayoutChange }: LayoutFilterProps) {
  const checkedColor = 'var(--color-store-list-filter-checked)';
  const uncheckedColor = 'var(--color-store-list-filter-unchecked)';

  return (
    <ul className="mb-4 flex w-full items-center justify-end gap-2">
      <li>
        <label
          htmlFor="list"
          className="flex cursor-pointer items-center justify-center"
          style={{ cursor: layoutFilterValue === 'list' ? 'default' : 'pointer' }}
        >
          <LineLayoutListIcon color={layoutFilterValue === 'list' ? checkedColor : uncheckedColor} />
          <input
            type="radio"
            name="layout"
            value="list"
            id="list"
            checked={layoutFilterValue === 'list'}
            onChange={() => handleLayoutChange('list')}
            className="hidden"
          />
        </label>
      </li>
      <li>
        <label
          htmlFor="grid"
          className="flex cursor-pointer items-center justify-center"
          style={{ cursor: layoutFilterValue === 'grid' ? 'default' : 'pointer' }}
        >
          <LineLayoutGridIcon color={layoutFilterValue === 'grid' ? checkedColor : uncheckedColor} />
          <input
            type="radio"
            name="layout"
            value="grid"
            id="grid"
            checked={layoutFilterValue === 'grid'}
            onChange={() => handleLayoutChange('grid')}
            className="hidden"
          />
        </label>
      </li>
    </ul>
  );
}
